class IMC_FILTER {

    constructor() {
        console.log("%c✔ FilterIMC Page  active", "color: #148f32");
        this._init(jQuery(this._params().formSelector));
    }

    _init(element) {
        let self = this;
        this.element = element;
        this.clearButton     =    $(this._params().clearBtnSelector);
        this.filterContainer = $(this._params().formSelector + ' ' + this._params().filterContainerSelector);
        this.searchField     = $(this._params().formSelector + ' ' + this._params().searchFieldSelector);
        this.theForm         = this.element.parents('#adminForm');


        this.clearButton.click(function(e) {
            self.clear();
        });

    }
    clear () {
        var self = this;

        self.getFilterFields().each(function(i, element) {
            $(element).val('');
        });

        self.searchField.val('');
        self.theForm.submit();
    }

    getFilterFields () {
        return this.filterContainer.find('select,input');
    }

    _params () {
        return {
            formSelector            : '#imc_page_filter',
            clearBtnSelector        : '.js-stools-btn-clear',
            filterContainerSelector : '.js-stools-container-filters',
            searchFieldSelector     : '#filter_search',
        }
    }


}


export default IMC_FILTER;
